import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/introConversionSagas";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const { filters, selectedFilters } = useSelector((state) => {
    const { filters, selectedFilters } = state.introConversion;
    return { filters, selectedFilters };
  }, shallowEqual);

  return (
    <MultiSelectDropdown
      options={filters}
      selectedFilters={selectedFilters}
      placeholder="Select Offers"
      numberDisplayed={0}
      maxSelect={6}
      enableMax
      enableOnly
      avoidSelectIfMaxSelected
      onSelectChange={(data) => dispatch(actionCreators.updateFilters(data))}
    />
  );
};
export default CustomDateRanges;
